<template>
  <v-dialog v-model="linkDialog" max-width="400">
    <v-card>
      <v-card-title class="text-h5">
        Informe o Link
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-text-field
          v-model="linkContent"
          variant="outlined"
          label="Link"
          type="url"
          class="mt-4"
          color="primary"
        />
        <v-checkbox
          v-model="openInNewTab"
          label="Abrir em nova aba"
          color="primary"
          hide-details
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          size="small"
          variant="text"
          @click="close"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          size="small"
          variant="text"
          @click="save"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  props: {
    initialLink: {
      type: String,
      default: '',
    },
    initialTarget: {
      type: String,
      default: '',
    },
  },

  emits: ['close', 'save'],

  setup(props, { emit }) {
    const linkContent = ref(props.initialLink)
    const openInNewTab = ref(props.initialTarget === '_blank')
    const linkDialog = ref(true)
    const close = () => {
      linkDialog.value = false
      emit('close')
    }
    const save = () => {
      linkDialog.value = false
      emit('save', {
        href: linkContent.value,
        target: openInNewTab.value ? '_blank' : '_self',
      })
    }
    return {
      linkContent,
      openInNewTab,
      linkDialog,
      close,
      save,
    }
  },
})
</script>
